var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSensitive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2502 12H1.50016C1.18252 12 0.953772 11.8611 0.813911 11.5833C0.674189 11.3056 0.698425 11.0419 0.886619 10.7923L4.50016 6L0.886619 1.20771C0.698425 0.958124 0.674189 0.694444 0.813911 0.416667C0.953772 0.138889 1.18252 0 1.50016 0H10.2502C10.4842 0 10.7059 0.0520833 10.9152 0.15625C11.1246 0.260417 11.3057 0.409722 11.4585 0.604167L14.8335 5.10417C15.0279 5.38194 15.1252 5.68056 15.1252 6C15.1252 6.31944 15.0279 6.61806 14.8335 6.89583L11.4585 11.3958C11.3057 11.5903 11.1246 11.7396 10.9152 11.8438C10.7059 11.9479 10.4842 12 10.2502 12Z",
    fill: "#44C4F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSensitive);
export default __webpack_public_path__ + "static/media/icon-sensitive.9662f987c4599f9d7f195395ae55f05b.svg";
export { ForwardRef as ReactComponent };